import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import wabmIcon from "../props/logo/logo192.png";
import { companyInfo } from "../data/companyInfo";

const Footer = () => {
  const [isDark, setIsDark] = useState(
    () => (localStorage.getItem("theme") || "dark") === "dark",
  );

  useEffect(() => {
    const theme = isDark ? "dark" : "light";
    localStorage.setItem("theme", theme);
    if (isDark) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [isDark]);

  return (
    <footer
      className="border-t mt-auto"
      style={{
        background: "var(--background-primary)",
        borderColor: "var(--border-color)",
      }}
    >
      <div className="max-w-7xl mx-auto px-6 pt-10 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {/* Column 1 — Brand */}
          <div className="flex flex-col gap-4">
            {/* Logo + name */}
            <div className="flex items-center gap-3">
              <img
                src={wabmIcon}
                alt="WaBM Partner logo"
                className="w-9 h-9 rounded-lg object-contain"
              />
              <span className="text-lg font-semibold text-themeColor3">
                {companyInfo.productName}
              </span>
            </div>

            {/* Description */}
            <p
              className="text-sm leading-6"
              style={{ color: "var(--text-primary)" }}
            >
              A unified partner dashboard for managing customer accounts,
              WhatsApp integrations, campaigns, and support operations — all in
              one place. Powered by {companyInfo.brandName}.
            </p>

            {/* Dark mode toggle + Copyright */}
            <div
              className="flex items-center gap-2 text-xs mt-auto flex-wrap"
              style={{ color: "var(--text-primary)" }}
            >
              <button
                onClick={() => setIsDark((prev) => !prev)}
                title={isDark ? "Switch to Light Mode" : "Switch to Dark Mode"}
                style={{
                  background: "none",
                  border: "none",
                  padding: 0,
                  cursor: "pointer",
                  color: "var(--text-primary)",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "5px",
                  fontSize: "12px",
                  transition: "color 0.2s ease",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.color = "var(--accent-color)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.color = "var(--text-primary)")
                }
              >
                {isDark ? "☀️" : "🌙"}
              </button>

              <span style={{ opacity: 0.4 }}>|</span>

              <span>
                © {companyInfo.copyrightYear} {companyInfo.productName}. All
                rights reserved.
              </span>
            </div>
          </div>

          {/* Column 2 — Useful Links */}
          <div className="flex flex-col items-start text-left md:items-end md:text-right">
            <h3
              className="text-sm font-semibold uppercase tracking-widest mb-4"
              style={{ color: "var(--text-primary)" }}
            >
              Useful Links
            </h3>
            <style>{`
              .footer-link {
                position: relative;
                display: inline-block;
                transition: color 0.2s ease, transform 0.2s ease;
              }
              /* underline grows left→right on mobile */
              .footer-link::after {
                content: '';
                position: absolute;
                bottom: -2px;
                left: 0;
                right: auto;
                width: 0;
                height: 1.5px;
                background: var(--accent-color);
                transition: width 0.25s ease;
              }
              .footer-link:hover {
                color: var(--accent-color) !important;
                transform: translateX(4px);
              }
              .footer-link:hover::after {
                width: 100%;
              }
              /* on md+: underline grows right→left, nudge flips */
              @media (min-width: 768px) {
                .footer-link::after {
                  left: auto;
                  right: 0;
                }
                .footer-link:hover {
                  transform: translateX(-4px);
                }
              }
            `}</style>

            <ul className="space-y-3">
              <li className="flex justify-start md:justify-end">
                <a
                  href="https://app.wabm.in/api-documentation"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-link text-sm"
                  style={{ color: "var(--text-primary)" }}
                >
                  API Documentation ↗
                </a>
              </li>

              <li className="flex justify-start md:justify-end">
                <a
                  href="https://app.wabm.in/qr-generator"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-link text-sm"
                  style={{ color: "var(--text-primary)" }}
                >
                  QR Generator ↗
                </a>
              </li>

              <li className="flex justify-start md:justify-end">
                <a
                  href="https://app.wabm.in/chat-button-generator"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-link text-sm"
                  style={{ color: "var(--text-primary)" }}
                >
                  Chat Button Generator ↗
                </a>
              </li>

              <li className="flex justify-start md:justify-end">
                <Link
                  to="/terms-of-service"
                  className="footer-link text-sm"
                  style={{ color: "var(--text-primary)" }}
                >
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
